import React from "react";
import RegexTextField, { RegexTextFieldProps } from "./RegexTextField";

const regexp = new RegExp(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);

const EmailTextField: React.FC<RegexTextFieldProps> = ({
  label,
  onChange,
  onChangeIsValid,
  required,
  value,
  variant,
}) => (
  <RegexTextField
    label={label}
    onChange={onChange}
    onChangeIsValid={onChangeIsValid}
    value={value}
    required={required}
    validationRegex={regexp}
    variant={variant}
  />
);

export default EmailTextField;
